module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "app-shell"
  }, [_c('app-header', {
    staticClass: "app-shell-header",
    on: {
      "click-menu": _vm.handleClickHeaderMenu,
      "click-back": _vm.handleClickHeaderBack
    }
  }, [_c('template', {
    slot: "logo"
  })], 2), _vm._v(" "), _c('menu-tabs', {
    staticClass: "menu-tabs"
  }), _vm._v(" "), _c('app-sidebar', {
    on: {
      "hide-sidebar": _vm.hideSidebar,
      "show-sidebar": _vm.showSidebar
    }
  }), _vm._v(" "), _c('div', {
    ref: "appViewWrapper",
    staticClass: "app-view-wrapper",
    class: {
      'app-view-with-header': _vm.appHeader.show
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.pageTransitionName
    },
    on: {
      "before-enter": _vm.handleBeforeEnter,
      "after-enter": _vm.handleAfterEnter,
      "after-leave": _vm.handleAfterLeave
    }
  }, [_c('keep-alive', [(!_vm.$route.meta.notKeepAlive) ? _c('router-view', {
    key: _vm.$route.fullPath,
    ref: "appView",
    staticClass: "app-view",
    class: {
      'overflow-scrolling-touch': _vm.overflowScrollingTouch
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.pageTransitionName
    },
    on: {
      "before-enter": _vm.handleBeforeEnter,
      "after-enter": _vm.handleAfterEnter,
      "after-leave": _vm.handleAfterLeave
    }
  }, [(_vm.$route.meta.notKeepAlive) ? _c('router-view', {
    key: _vm.$route.fullPath,
    ref: "appView",
    staticClass: "app-view",
    class: {
      'overflow-scrolling-touch': _vm.overflowScrollingTouch
    }
  }) : _vm._e()], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e64dc28","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loaders/theme-loader.js??ref--2-1!./src/App.vue
// module id = 499
// module chunks = 7